'use strict';



const EventEmitter = require('events').EventEmitter;
const $ = require('jquery');
const shortid = require('shortid');
const getFragment = require('./get-fragment');
const confirmCancelLoanpartSale = require('./confirm-loanpart-sale-cancellation');
const loadingClassName = 'c-table__cell--is-loading';
const openClassName = 'c-table__cell--is-expanded';



module.exports = class LoanPartsTable extends EventEmitter {



	constructor($loan) {

		super();

		const loan = $loan.data('loan');
		const $toggle = $loan.find('.js-toggle');
		const $container = $(`[data-loan-parts-container=${loan}]`);

		this.id = shortid();
		$container.attr('id', this.id);

		this.elements = {
			$loan,
			$toggle,
			$container,
			$inner: $container.find('.js-loan-parts-inner')
		};

		this.state = {
			loan,
			view: $loan.data('loan-view'),
			statusFilters: $loan.data('status-filters'),
			open: false,
			loaded: false,
			content: null,
			hasOpened: false
		};

		$toggle.on('click', e => {
			e.preventDefault();
			this.toggle();
		});

	}



	toggle(e) {
		return this.state.open ?
			this.close() :
			this.open();
	}



	open() {

		const { $container, $inner, $loan } = this.elements;
		const append = !this.state.loaded;

		$loan.addClass(openClassName);

		this.getContent(res => {

			this.state.open = true;
			this.state.loaded = true;
			this.state.content = res;

			this.emit('open', this.id);

			if(append) {
				$inner.html(res);
				this.emit('append', this.id);
			}

			$container.show();

			if(!this.state.hasOpened) {
				this.state.hasOpened = true;
				confirmCancelLoanpartSale($inner.find('.js-cancel-loanpart-sale'));
			}

		});

	}



	close() {
		this.elements.$loan.removeClass(openClassName);
		this.elements.$container.hide();
		this.state.open = false;
		this.emit('close');
	}



	getContent(next = function() {}) {

		if(this.state.loaded) {
			return next(this.state.content);
		}

		this.onLoadStart();

		getFragment('Loan/UserLoanParts', {
			loan: this.state.loan,
			view: this.state.view,
			'status-filters': this.state.statusFilters
		}).done(res => {
			this.onLoadEnd();
			next(res);
		});

	}



	onLoadStart() {
		this.elements.$loan.addClass(loadingClassName);
	}



	onLoadEnd() {
		this.elements.$loan.removeClass(loadingClassName);
	}



};
